module.exports = __webpack_public_path__ + "static/media/phone-01.3682d6c3.png";